import axios, { AxiosInstance } from "axios"
import api from "@/services/api"
import { IntegrationWithSettings, IntegrationSettings, IntegrationSummary, IntegrationService, IntegrationLog, IntegrationStatus, IntegrationOutOption } from "@/types/integration"

class IntegrationApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async integrationsGet (): Promise<IntegrationWithSettings[]> {
		return (await this.axios.get("/integration")).data
	}

	public async integrationsGetActive (): Promise<IntegrationSummary[]> {
		return (await this.axios.get("/integration/active")).data
	}
	public async integrationsSave (settings: IntegrationSettings): Promise<void> {
		return (await this.axios.put("/integration", settings)).data
	}

	public async integrationServicesGet (integrationKey: string): Promise<IntegrationService[]> {
		return (await this.axios.get("/service/" + integrationKey)).data
	}

	public async logGet (integrationKey: string, until: Date | null = null): Promise<IntegrationLog[]> {
		return (await this.axios.get("/integration/logs", {
			params: {
				integrationKey,
				until
			}
		})).data
	}

	public async statusGet (integrationKey: string): Promise<IntegrationStatus> {
		return (await this.axios.get("/integration/status/" + integrationKey)).data
	}

	public async forceRun (integrationKey: string): Promise<void> {
		await this.axios.post("/integration/forcerun/" + integrationKey)
	}

	public async enabledOutputs (): Promise<IntegrationOutOption[]> {
		return (await this.axios.get("/integration/outputs")).data
	}

	public async sendRecord (caseId: string, integrationKey: string, output: string): Promise<void> {
		await this.axios.post(`/integration/${integrationKey}/send/${output}/${caseId}`)
	}
}

const integrationApi = new IntegrationApi()
export default integrationApi
